import TopBar from "./top-bar";

export default TopBar;